import { useEffect, useState } from 'react';
import { Text, Card, Form, FormLayout, Icon, TextField, Button, InlineStack, BlockStack, Box, Link, Image, InlineError, Spinner } from '@shopify/polaris';
import { usePartnerUp } from '../providers/PartnerUpStoreProvider';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { LogoInstagramIcon, LogoTiktokIcon, LogoYoutubeIcon } from '@shopify/polaris-icons';

export default function Login() {
  const { auth, user, refetchUser } = usePartnerUp();
  const [loginType, setLoginType] = useState(null); // ['email', 'google']
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  useEffect(() => {
    // listen for auth state changes
    const unsub = auth.onAuthStateChanged((authUser) => {
      if (auth._isInitialized && authUser) {
        refetchUser().then(() => {
          if (user) {
            navigate('/')
          } else {
            navigate('/onboarding')
          }
        });
      }
    })
    return unsub;
  }, []);

  let content = null;
  if (!auth._isInitialized) {
    content = (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Spinner size="large" color="teal" />
      </div>
    )
  } else if (!loginType) {
    content = (
      <Box padding="500">
        <Form onSubmit={() => { setLoginType('email') }}>
          <FormLayout>
            <BlockStack align="center" gap="500">
              {
                /*
                <>
                  <TextField
                    label="Email"
                    type="email"
                    value={email}
                    onChange={setEmail}
                    autoFocus
                    />
                  <Button size="large" variant="primary" submit>Continue</Button>
                  <InlineStack align="center">
                    <Text>Or</Text>
                  </InlineStack>
                  </>
                  */
              }
              <BlockStack gap="200">
                <InlineStack align="center">
                  <img width="80px" src="https://assets.codepen.io/6060109/partnerup.svg" alt="" />
                </InlineStack>
                <Button size="large" onClick={async () => {
                  const provider = new GoogleAuthProvider();
                  await signInWithPopup(auth, provider);
                }}>
                  <InlineStack gap="100">
                    <img width="20px" src="https://assets.codepen.io/6060109/g-logo.webp" />
                    <Text>
                      Sign in with Google
                    </Text>
                  </InlineStack>
                </Button>
                <InlineStack align="center">
                  <Text variant="bodySm" tone="subdued">Use the same Google Account as your Chrome profile</Text>
                </InlineStack>
              </BlockStack>

              {
                /*
                <InlineStack align="center">
                  <Link removeUnderline>Create Account</Link>
                </InlineStack>
                  */
              }
            </BlockStack>
          </FormLayout>
        </Form>
      </Box>
    )
  } else if (loginType === 'email') {
    content = (
      <Box padding="500">
        <Form onSubmit={async () => {
          try {
            await signInWithEmailAndPassword(auth, email, password)
            navigate('/')
          } catch (e) {
            if (e.message.includes('user-not-found')) {
              setError('User not found')
            } else if (e.message.includes('wrong-password')) {
              setError('Incorrect Password')
            } else {
              setError(e.message)
            }
          }
        }}>
          <FormLayout>
            <BlockStack align="center" gap="300">
              <TextField
                label="Password"
                type="password"
                value={password}
                onChange={setPassword}
              />
              <InlineError message={error} fieldID="password" />
              <Link removeUnderline>Forgot password?</Link>
              <Button variant="primary" submit>Log in</Button>
              <InlineStack align="center">
                <Link removeUnderline onClick={() => setLoginType(null)}>Back</Link>
              </InlineStack>
            </BlockStack>
          </FormLayout>
        </Form>
      </Box>
    )
  }

  return (
    <div style={{
      width: '100vw', height: '100vh',
      background: 'rgb(80,109,250)',
      background: 'linear-gradient(201deg, rgba(80,109,250,1) 57%, rgba(138,88,247,1) 100%)'
    }}>
      <div style={{ padding: '20px' }}>
        <Image source="https://assets.codepen.io/6060109/PartnerUp+3.png" width="150" />
      </div>
      <div style={{ height: '80%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: '400px', margin: '0 auto', color: 'white' }}>
          <BlockStack gap="300">
            <Card title="Log in">
              {content}
            </Card>
            <BlockStack gap="100" inlineAlign="center">
              <Text variant="bodyLg" tone="text-inverse">Find qualified influencers in minutes</Text>
              <InlineStack gap="300">
                <Icon source={LogoInstagramIcon} tone="inherit" />
                <Icon source={LogoTiktokIcon} color="teal" />
                <Icon source={LogoYoutubeIcon} color="teal" />
              </InlineStack>
            </BlockStack>
          </BlockStack>
        </div>
      </div>
    </div>
  )
}
